import React, { Component } from "react";
import DashboardIcon from "@material-ui/icons/Dashboard";
import Typography from "@material-ui/core/Typography";
import WhatshotIcon from "@material-ui/icons/Whatshot";
import PeopleIcon from "@material-ui/icons/People";
import GroupIcon from "@material-ui/icons/Group";
import CoffeeIcon from "@material-ui/icons/LocalCafe";
import SettingsIcon from "@material-ui/icons/Settings";
import PollIcon from "@material-ui/icons/Poll";

const menu = [
  {
    icon: <DashboardIcon />,
    path: "/",
    route: "dashboard",
    text: "Dashboard",
    hasAccess: true
  },
  {
    icon: <GroupIcon />,
    route: "team",
    text: "Mon Équipe",
    hasAccess: true
  },
  {
    icon: <PollIcon />,
    route: "polls",
    text: "Sondages",
    hasAccess: true
  },
  {
    icon: <WhatshotIcon />,
    route: "actions",
    text: "Actions",
    hasAccess: true
  },
  {
    icon: <CoffeeIcon />,
    route: "coffee",
    text: "Random Coffee",
    hasAccess: true
  },
  {
    icon: <SettingsIcon />,
    route: "settings",
    text: "Paramètres",
    hasAccess: true
  }
];

export default menu;
